import { EInvoiceStatus } from '../constants/eInvoiceStatus'
import { parseAttachmentDataJson } from './parseAttachmentDataJson'

export interface EInvoiceLifecycleFromDataJson {
  eInvoiceStatus: EInvoiceStatus | null
  reasonCode: string | null
}

const isEInvoiceStatus = (value: unknown): value is EInvoiceStatus =>
  typeof value === 'string' && (Object.values(EInvoiceStatus) as string[]).includes(value)

export const getEInvoiceLifecycleFromDataJson = (
  dataJson: string | null | undefined,
): EInvoiceLifecycleFromDataJson | null => {
  const parsed = parseAttachmentDataJson(dataJson)

  if (!parsed) {
    return null
  }

  return {
    eInvoiceStatus: isEInvoiceStatus(parsed.eInvoiceStatus) ? parsed.eInvoiceStatus : null,
    reasonCode: typeof parsed.reasonCode === 'string' ? parsed.reasonCode : null,
  }
}
